export function offcanvasOverrides(headerElement) {
    
    const ensureTopMenuPosition = function () {
        
        // Get the main navbar
        const navbarElement = headerElement.querySelector('nav.navbar');

        // Check if there is a top menu at all, if not there's no need to do anything
        const topmenu = headerElement.querySelector('.navbar-nav.top-menu');
        if (!topmenu || topmenu.length === 0)
            return;

        // Check if there's an offcanvas, if not there's no need to do anything
        const offcanvasBody = navbarElement.querySelector('.offcanvas .offcanvas-body');
        if (!offcanvasBody || offcanvasBody.length === 0)
            return;

        // Check if there's a specific target for the top menu
        const desktopTargetSelector = topmenu.getAttribute('data-desktop-target');
        const desktopTargetElement = desktopTargetSelector && desktopTargetSelector.length > 0 ? headerElement.querySelector(desktopTargetSelector) : navbarElement;

        // We can't use visibility of "navbar-toggler" since this can be used in a "hybrid menu"
        // where mobile nav is always visible and top menu are used as main menu on desktop sizes.
        // Instead get actual break point from element.
        let breakpoint = window.getComputedStyle(navbarElement, '::after').getPropertyValue('content');
        if (!breakpoint || breakpoint === 'none')
            return;

        breakpoint = parseFloat(breakpoint.replace(/"/g, '').replace('px', ''));

        if (isNaN(breakpoint))
            return;

        // If larger than breakpoint we are on "desktop".
        // Ensure top menu isn't in the offcanvas.
        if (window.innerWidth > breakpoint) {

            // If parent isn't offcanvas we don't need to to anything.
            if (topmenu.parentElement !== offcanvasBody)
                return;                                                       

            // Move out of offcanvas
            console.debug('Moving top menu for desktop render...');
            desktopTargetElement.prepend(topmenu);
            return;
        }
        
        // If smaller than breakpoint, ensure topmeny is in offcanvas.
        // If already present we don't need to do anything.
        if (topmenu.parentElement === offcanvasBody)
            return;

        // Move in to offcanvas
        console.debug('Moving back top menu for non-desktop render...');
        offcanvasBody.prepend(topmenu);
    };

    const init = function () {
        ensureTopMenuPosition();
    };

    // Re-init on resize
    window.onresize = init;

    init();
}